import moment from 'moment';

export const getCoveredPeriodFromDates = ({ standardCoveredPeriodStartDate, standardCoveredPeriodEndDate }) => {
  const result = [
    moment(standardCoveredPeriodStartDate).format('ll'),
    moment(standardCoveredPeriodEndDate).format('ll'),
  ];
  return result;
};
